<template>
  <section v-if="!isMobile">
    <UserNavigation current-page="betslip" />
    <div class="wrap" style="min-height: 800px; margin-top:100px;">
      <div class="bet_wrap">
        <div class="example1">
          <div class="panel panel-primary">
            <div
              v-if="isLoading"
              style="text-align: center; padding-top: 20%; padding-bottom: 20%"
            >
              <Loading></Loading>
            </div>
            <form name="cbFormAll1" class="ng-pristine ng-valid" v-else>
              <div id="tableAll1_wrapper" class="dataTables_wrapper no-footer">
                <table
                  id="tableAll1"
                  cellspacing="0"
                  cellpadding="0"
                  width="100%"
                  class="dataTable no-footer"
                  role="grid"
                  style="width: 100%"
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting" style="width: 60px">
                        <input type="checkbox" class="alltab_chckall" />
                      </th>
                      <th class="sorting" style="width: 220px">베팅 NO</th>
                      <th
                        class="sorting_desc"
                        style="width: 120px"
                        aria-sort="descending"
                      >
                        베팅 일시
                      </th>
                      <th class="sorting_asc" style="width: 130px">
                        베팅 종목
                      </th>
                      <th class="sorting" style="width: 130px">베팅 결과</th>
                      <th class="sorting" style="width: 168px">배팅 금액</th>
                      <th class="sorting" style="width: 143px">배당율</th>
                      <th class="sorting" style="width: 144px">
                        예상 적중 금액
                      </th>
                      <th class="sorting" style="width: 71px">폴더</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(betSlip, index) in betSlips">
                      <tr
                        role="row"
                        class="odd"
                        :key="'betSlip' + betSlip.id"
                      >
                        <td>
                          <input
                            type="checkbox"
                            name="cb"
                            class="dTable1_chk"
                            v-model="selectedBetSlips"
                            :value="betSlip.id"
                          />
                        </td>
                        <td @click="toggle(index)">
                          {{ betSlip.id }} <br>
                          {{ getTypeText(betSlip.type) }}
                        </td>
                        <td @click="toggle(index)" class="sorting_1">
                          {{ betSlip.created_at | formatDate("YYYY-MM-DD HH:mm:ss") }}
                        </td>
                        <td @click="toggle(index)">
                          스포츠
                          {{ betSlip.betDetails && betSlip.betDetails.length > 1 ? "외" : "" }}
                        </td>
                        <td @click="toggle(index)">
                          <span :class="getStatusClass(betSlip.result)">
                            {{ getResultText(betSlip.result) }}
                          </span>
                        </td>
                        <td @click="toggle(index)">
                          <span :class="getStatusClass(betSlip.result)">
                            {{ formatAmount(betSlip.total_amount) }}
                          </span>
                        </td>
                        <td @click="toggle(index)">
                          <span :class="getStatusClass(betSlip.result)">
                            {{ Number(betSlip.total_odds).toFixed(2) }}
                          </span>
                        </td>
                        <td @click="toggle(index)">
                          <span :class="getStatusClass(betSlip.result)">
                            {{ formatAmount(betSlip.expected_prize) }}
                          </span>
                        </td>
                        <td @click="toggle(index)">
                          {{ betSlip.betDetails ? `${betSlip.betDetails.length}폴더` : "단폴더" }}
                        </td>
                      </tr>
                      <transition name="fade" :key="'betSlipDetail' + index">
                        <tr v-if="opened.includes(index) && betSlip.betDetails && betSlip.betDetails.length > 0">
                          <td colspan="9">
                            <div class="sub_table">
                              <table
                                class="panel-body bet_dd_p"
                                cellpadding="0"
                                cellspacing="0"
                                :class="{
                                  acc_list_table_in_01: betSlip.result === 'exception',
                                  acc_list_table_in_02: betSlip.result === 'miss',
                                  acc_list_table_in_04: betSlip.result === 'hit',
                                  acc_list_table_in_03: betSlip.result === 'wait' || betSlip.status === 'pending',
                                }"
                              >
                                <tbody>
                                  <tr>
                                    <td class="acc_list_table_in_t" width="11%">
                                      경기일시
                                    </td>
                                    <td class="acc_list_table_in_t" width="15%">
                                      리그
                                    </td>
                                    <td class="acc_list_table_in_t" width="18%">
                                      팀
                                    </td>
                                    <td class="acc_list_table_in_t" width="14%">
                                      마켓
                                    </td>
                                    <td class="acc_list_table_in_t" width="14%">
                                      베팅명
                                    </td>
                                    <td class="acc_list_table_in_t" width="6%">
                                      배당율
                                    </td>
                                    <td class="acc_list_table_in_t" width="6%">
                                      결과
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="detail in betSlip.betDetails"
                                    :key="'betDetail' + detail.id"
                                  >
                                    <td class="bet_time">
                                      {{ detail.game_start_time | formatDate("YYYY-MM-DD HH:mm:ss") }}
                                    </td>
                                    <td class="bet_name">
                                      {{ detail.league_name }}
                                    </td>
                                    <td class="bet_name">
                                      {{ detail.home_team_name }} - {{ detail.away_team_name }}
                                    </td>
                                    <td class="bet_type">
                                      {{ getMarketName(detail) }}
                                    </td>
                                    <td class="bet_type">
                                      {{ detail.bet_name }}
                                    </td>
                                    <td class="bet_type">
                                      {{ Number(detail.odds).toFixed(2) }}
                                    </td>
                                    <td class="beting_in_btn">
                                      <span
                                        :class="{
                                          'text-yellow': detail.result === 'exception',
                                          'text-red': detail.result === 'miss',
                                          'text-green': detail.result === 'hit',
                                          'text-gray': detail.result === 'wait',
                                        }"
                                      >
                                        {{ getResultText(detail.result) }}
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div
                                class="btnBox02"
                                style="margin-top: 10px; text-align: right"
                                v-if="canCancelBetSlip(betSlip) || getFreebetClaimType(betSlip) || getLeagueEventEligibleSlip(betSlip).length > 0 || getBettingBonusEligibleSlip(betSlip)"
                              >
                                <template v-if="!cancelLoading.includes(betSlip.id) && !claimLoading.includes(betSlip.id)">
                                  <a
                                    v-if="getFreebetClaimType(betSlip) === 'one_folder_miss'"
                                    @click="onClaimFreebetSlip(betSlip.id, 'one_folder_miss')"
                                    class="btn05"
                                    style="margin-right: 5px"
                                    >한폴낙 신청</a
                                  >
                                  <a
                                    v-else-if="getFreebetClaimType(betSlip) === 'all_miss'"
                                    @click="onClaimFreebetSlip(betSlip.id, 'all_miss')"
                                    class="btn05"
                                    style="margin-right: 5px"
                                    >올미당 신청</a
                                  >
                                  <a
                                    v-for="ev in getLeagueEventEligibleSlip(betSlip)"
                                    :key="'le-'+betSlip.id+'-'+ev.eventId"
                                    @click="onClaimLeagueEventSlip(betSlip.id, ev.eventId, ev.eventName)"
                                    class="btn05"
                                    style="margin-right: 5px"
                                    >{{ ev.eventName }} 신청</a
                                  >
                                  <a
                                    v-if="getBettingBonusEligibleSlip(betSlip)"
                                    @click="onClaimBettingBonusSlip(betSlip.id, getBettingBonusEligibleSlip(betSlip).eventId, getBettingBonusEligibleSlip(betSlip).eventName)"
                                    class="btn05"
                                    style="margin-right: 5px"
                                    >{{ getBettingBonusEligibleSlip(betSlip).eventName }} 신청</a
                                  >
                                  <a
                                    v-if="canCancelBetSlip(betSlip)"
                                    @click="cancelBetSlip(betSlip.id)"
                                    class="btn05"
                                    >베팅 취소</a
                                  >
                                </template>
                                <template v-else>
                                  <Loading></Loading>
                                </template>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </transition>
                    </template>
                  </tbody>
                </table>

                <div class="pagination-container" v-if="pagination.hasMore">
                  <button @click="loadMore" class="btn05">더보기</button>
                </div>
                <div class="btnBox02">
                  <span style="color: #999; margin-right: 10px;">
                    전체 {{ pagination.total }}개 중 {{ pagination.count }}개 표시
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div v-else>
    <div class="header2">
      <div class="left">
        <a @click="$router.push('/main')" class="btn-prev"></a>
      </div>
      <h2>베팅슬립</h2>
      <div class="right">
        <button class="m_delete_btn" @click="deleteAllBetSlips">전체삭제</button>
      </div>
    </div>
    <UserNavigation current-page="betslip" />

    <div class="wrap">
      <div class="tab_content" style="background-color: rgb(25, 26, 27); display: block;">

        <form name="form_search" action="./bet_lst" method="GET">
          <input type="hidden" name="tab" value="ALL">
          <input type="hidden" name="pages" value="1">

          <div class="my_search_wrap" style="margin:0 0 10px 0;">
            <select class="input_style01" name="game">
              <option value="SPORT">스포츠</option>
<!--              <option value="ASIAGAME">아시안게이밍</option>-->
<!--              <option value="EVOLUTION">에볼루션 &amp; NETENT, RED TIGER, STG</option>-->
<!--              <option value="ALEA_VS">ALEA 가상게임</option>-->
<!--              &lt;!&ndash;<option value="MRSLOTTY_VG">MrSlotty 가상게임</option>&ndash;&gt;-->
<!--              <option value="PROGMATIC">프로그매틱</option>-->
<!--              <option value="MG_SLOT">MG 슬롯</option>-->
<!--              <option value="MG_CASINO">MG 카지노</option>-->
            </select>
          </div>

<!--          <div class="my_search_wrap">-->
<!--            <select class="input_style01" name="time_kind" onchange="change_time_kind(this)">-->
<!--              <option value="0">전체</option>-->
<!--              <option value="24">최근 24시간</option>-->
<!--              <option value="3">최근 3일</option>-->
<!--              <option value="7">최근 7일</option>-->
<!--              &lt;!&ndash;<option value="31">최근 한달</option>&ndash;&gt;-->
<!--            </select>-->
<!--          </div>-->
          <div class="my_search_wrap">
            <table cellspacing="0" cellpadding="0" border="0" width="95%" style="margin-left: 4px;">
              <tbody><tr>
                <td width="49%"><input class="input_style01 hasDatepicker" readonly="" value="" placeholder="검색시작시간" id="date1" name="date1" type="date" v-model="payload.startDate"></td>
                <td style="width:80px;padding: 0px 20px 0px 20px;text-align:center">~</td>
                <td width="49%"><input class="input_style01 hasDatepicker" readonly="" value="" placeholder="검색종료시간" id="date2" name="date2" type="date" v-model="payload.endDate"></td>
              </tr>
              </tbody></table>
          </div>

        </form>
        <dl width="100%" style="">
          <br>
          <div class="snb_wrap" id="BC_TAB">
            <ul>
              <li><a @click="setStatusFilter(null)"><span id="TAB_ALL" :class="{'snb_on': !payload.status, 'snb': payload.status}">전체</span></a></li>
              <li><a @click="setStatusFilter('pending')"><span id="TAB_PENDING" :class="{'snb_on': payload.status === 'pending', 'snb': payload.status !== 'pending'}">대기중</span></a></li>
              <li><a @click="setStatusFilter('completed')"><span id="TAB_COMPLETED" :class="{'snb_on': payload.status === 'completed', 'snb': payload.status !== 'completed'}">완료</span></a></li>
              <li><a @click="setStatusFilter('cancelled')"><span id="TAB_CANCELLED" :class="{'snb_on': payload.status === 'cancelled', 'snb': payload.status !== 'cancelled'}">취소</span></a></li>
            </ul>
          </div>
          <dt style="width:100%; padding:2px 0px 0px 0px;margin :0px 0px 0px 0px;">
            <div class="bet_gray" style="text-align: center;" v-if="isLoading">
              <Loading></Loading>
            </div>
            <div class="bet_gray" v-if="!isLoading && betSlips.length === 0" style="width:100%;padding :50px 0px 50px 5px;margin :0px 0px 0px 0px;text-align:center;">
              베팅슬립이 없습니다.
            </div>
            <template v-for="(betSlip, index) in betSlips">
              <div
                  class="m_betting_div"
                  :key="'betSlip' + betSlip.id"
              >
                <div
                    class="total_betting_div"
                    :class="{
                      'bg-y': betSlip.result === 'exception',
                      'bg-r': betSlip.result === 'miss',
                      'bg-g': betSlip.result === 'hit',
                      'bg-gr': betSlip.result === 'wait',
                    }"
                    @click="toggle(index)"
                >
                  <table border="0" width="100%">
                    <tr>
                      <td class="text-gray">
                        일시 :
                        <span>{{ betSlip.created_at | formatDate("YY-MM-DD HH:mm:ss") }}</span>
                      </td>
                      <td width="20%" rowspan="6">
                        <button type="button" v-if="canCancelBetSlip(betSlip)">
                          <span @click.stop="cancelBetSlip(betSlip.id)">취소</span>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td style="color: rgb(153, 153, 153)">
                        베팅슬립ID :
                        <span>{{ betSlip.id }} / {{ betSlip.type }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        폴더
                        <span class="orange--text">{{ betSlip.betDetails ? betSlip.betDetails.length : 1 }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        베팅금액
                        <span class="orange--text">{{ formatAmount(betSlip.total_amount) }}</span>원
                      </td>
                    </tr>
                    <tr>
                      <td>
                        베당율
                        <span class="orange--text">{{ Number(betSlip.total_odds).toFixed(2) }}</span>배
                      </td>
                    </tr>
                    <tr>
                      <td>
                        (예상)적중금액
                        <span class="orange--text">{{ formatAmount(betSlip.expected_prize) }}</span>원
                      </td>
                    </tr>
                  </table>
                </div>
                <transition name="fade">
                  <div style="" v-if="opened.includes(index) && betSlip.betDetails && betSlip.betDetails.length > 0">
                    <div
                        class="sub_betting_div"
                        :class="{
                            'border-y': detail.result === 'exception',
                            'border-r': detail.result === 'miss',
                            'border-g': detail.result === 'hit',
                            'border-gr': detail.result === 'wait',
                          }"
                        v-for="detail in betSlip.betDetails"
                        :key="'betDetail' + detail.id"
                    >
                      <table
                          border="0"
                          width="100%"
                          style="color: white; font-size: 14px; padding-left: 10px"
                      >
                        <tr class="text-gray">
                          <td colspan="2" class="pt-2 text-gray">
                            {{ detail.game_start_time | formatDate("YY-MM-DD HH:mm") }}
                            |
                            {{ detail.league_name }}
                          </td>
                        </tr>
                        <tr class="text-gray">
                          <td class="text-gray">게임아이디: {{ detail.game_id }}</td>
                          <td
                              class="text-gray text-right pr-3"
                              style="text-align: right; line-height: 1.4"
                          >
                            {{ Number(detail.odds).toFixed(2) }}
                          </td>
                        </tr>
                        <tr>
                          <td style="color: white">
                            {{ detail.home_team_name }}
                            <span class="grey--text text-gray"> vs </span>
                            {{ detail.away_team_name }}
                          </td>
                          <td
                              class="text-right pr-3"
                              style="text-align: right; line-height: 1.4;"
                          >
                            <span v-if="detail.result == 'hit'" style="color: #44d344">{{ getResultText(detail.result) }}</span>
                            <span v-else-if="detail.result == 'miss'" style="color: #ff6b6b">{{ getResultText(detail.result) }}</span>
                            <span v-else-if="detail.result == 'exception'" style="color: #ffd93d">{{ getResultText(detail.result) }}</span>
                            <span v-else-if="detail.result == 'cancelled'" style="color: white">취소</span>
                            <span v-else style="color: white">{{ getResultText(detail.result) }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2" class="pb-2" style="color: white">
                            <span style="color: deepskyblue">{{ getMarketName(detail) }}</span>
                            / {{ detail.bet_name }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div
                        class="btnBox02"
                        style="margin-top: 10px; margin-bottom: 50px"
                        v-if="canCancelBetSlip(betSlip) || getFreebetClaimType(betSlip) || getLeagueEventEligibleSlip(betSlip).length > 0 || getBettingBonusEligibleSlip(betSlip)"
                    >
                      <template
                        v-if="!cancelLoading.includes(betSlip.id) && !claimLoading.includes(betSlip.id)"
                      >
                        <a
                          v-if="getFreebetClaimType(betSlip) === 'one_folder_miss'"
                          @click="onClaimFreebetSlip(betSlip.id, 'one_folder_miss')"
                          class="btn05"
                          style="width: 100%; margin-bottom: 5px"
                          >한폴낙 신청</a
                        >
                        <a
                          v-else-if="getFreebetClaimType(betSlip) === 'all_miss'"
                          @click="onClaimFreebetSlip(betSlip.id, 'all_miss')"
                          class="btn05"
                          style="width: 100%; margin-bottom: 5px"
                          >올미당 신청</a
                        >
                        <a
                          v-for="ev in getLeagueEventEligibleSlip(betSlip)"
                          :key="'mle-'+betSlip.id+'-'+ev.eventId"
                          @click="onClaimLeagueEventSlip(betSlip.id, ev.eventId, ev.eventName)"
                          class="btn05"
                          style="width: 100%; margin-bottom: 5px"
                          >{{ ev.eventName }} 신청</a
                        >
                        <a
                          v-if="getBettingBonusEligibleSlip(betSlip)"
                          @click="onClaimBettingBonusSlip(betSlip.id, getBettingBonusEligibleSlip(betSlip).eventId, getBettingBonusEligibleSlip(betSlip).eventName)"
                          class="btn05"
                          style="width: 100%; margin-bottom: 5px"
                          >{{ getBettingBonusEligibleSlip(betSlip).eventName }} 신청</a
                        >
                        <a
                          v-if="canCancelBetSlip(betSlip)"
                          @click="cancelBetSlip(betSlip.id)"
                          class="btn05"
                          style="width: 100%"
                          >베팅 취소</a
                        >
                      </template>
                      <template v-else>
                        <Loading></Loading>
                      </template>
                    </div>
                  </div>
                </transition>
              </div>
            </template>
            <div class="pagination-container" v-if="pagination.hasMore" style="text-align: center; margin: 20px 0;">
              <button @click="loadMore" class="btn05">더보기</button>
            </div>
            <div style="text-align: center; color: #999; margin: 20px 0;">
              전체 {{ pagination.total }}개 중 {{ pagination.count }}개 표시
            </div>
          </dt>
        </dl>
      </div>
    </div>
    <!-- 인디케이터 -->
<!--    <div-->
<!--      class="m-game-wrap"-->
<!--      v-if="!lists"-->
<!--      style="min-height: 100px; text-align: center"-->
<!--    >-->
<!--      <div class="m-game-body">-->
<!--        <div class="m-game">-->
<!--          <div>-->
<!--            <Loading></Loading>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    &lt;!&ndash; 인디케이터 &ndash;&gt;-->
<!--    <div-->
<!--      class="m-game-wrap"-->
<!--      v-if="isLoading && lists.length === 0"-->
<!--      style="min-height: 100px; text-align: center"-->
<!--    >-->
<!--      <div class="m-game-body">-->
<!--        <div class="m-game">-->
<!--          <div class="team">-->
<!--            <div class="name" style="margin-top: 20px">-->
<!--              <span>베팅내역이 없습니다.</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import UserNavigation from "@/components/UserNavigation";
import {mapState} from "vuex";

export default {
  name: "BetSlip",
  components: {
    Loading,
    UserNavigation,
  },
  data: function () {
    return {
      isLoading: false,
      loading: {
        isLoading: true,
        color: "orange",
        size: "80px",
      },
      payload: {
        status: null,  // "pending", "cancelled", "completed" 등
        limit: 20,
        offset: 0,
      },
      selectedBetSlips: [],
      opened: [],
      cancelLoading: [],
      claimLoading: [],
    };
  },
  mounted: function () {
    this.fetchBetSlips();
  },
  computed: {
    isMobile: function () {
      return this.$store.state.page.isMobile;
    },
    freebetEventSetting() {
      return this.$store.getters['FREEBET_EVENT_SETTING'];
    },
    ...mapState({
      user: state => state.user.user,
      betSlips: state => state.user.betSlipHistory.betSlips || [],
      pagination: state => state.user.betSlipHistory.pagination || {
        total: 0,
        count: 0,
        limit: 20,
        offset: 0,
        hasMore: false
      }
    }),
  },
  methods: {
    /**
     * 베팅슬립 목록 조회
     */
    fetchBetSlips: function (append = false) {
      this.isLoading = true;

      const requestData = {
        type: 'all',
        append,
        limit: this.payload.limit,
        offset: this.payload.offset,
      };

      if (this.payload.status) {
        requestData.status = this.payload.status;
      }

      this.$store.dispatch('BETSLIP_HISTORY', requestData)
        .then((response) => {
          if (!response.data.success) {
            alert(response.data.msg || '베팅슬립 조회에 실패했습니다.');
          }
        })
        .catch(err => {
          console.error('베팅슬립 조회 오류:', err);
          alert(err.response?.data?.msg || err.response?.data?.error || '베팅슬립 조회에 실패했습니다.');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    /**
     * 한폴낙/올미당(슬립) 자격 자동 판단 (BettingResult.vue getFreebetEligible 패턴 차용)
     * @returns {string|null} 'one_folder_miss' | 'all_miss' | null
     */
    getFreebetClaimType: function (betSlip) {
      const settings = this.freebetEventSetting;
      if (!settings) return null;
      if (!betSlip) return null;

      // 이미 지급된 슬립 제외 (백엔드 my-bets 응답 플래그)
      if (betSlip.freebet_event_claimed) return null;
      // 베팅보너스(슬립)로 차단된 슬립 제외
      if (betSlip.betting_bonus_blocks_other) return null;
      // 프리벳 슬립 제외
      if (betSlip.is_freebet === true || betSlip.is_freebet === 1) return null;
      // 취소된 슬립 제외 (pending/complete만 통과)
      if (betSlip.status !== 'pending' && betSlip.status !== 'complete') return null;

      const user = this.$store.state.user.user;
      const details = betSlip.betDetails || [];
      if (details.length === 0) return null;

      // 결과 미확정 폴더 있으면 제외
      const waitCount = details.filter(d => d.result === 'wait').length;
      if (waitCount > 0) return null;

      // 적특(exception) 또는 무효(return) 폴더 있으면 제외
      const exceptionCount = details.filter(d => d.result === 'exception' || d.result === 'return').length;
      if (exceptionCount > 0) return null;

      const missCount = details.filter(d => d.result === 'miss').length;
      const hitCount = details.filter(d => d.result === 'hit').length;
      const betAmount = Number(betSlip.total_amount);

      // 한폴낙
      if (settings.oneFolderMiss?.available === 'Y' && user?.one_folder_miss === 'Y') {
        const s = settings.oneFolderMiss;
        if (betAmount >= s.minBettingAmount) {
          const highOddsFolders = details.filter(
            d => s.minOdds === 0 || parseFloat(d.odds) >= s.minOdds
          );
          if (highOddsFolders.length >= s.minFolderCount) {
            if (missCount === 1 && hitCount === details.length - 1) {
              return 'one_folder_miss';
            }
          }
        }
      }

      // 올미당
      if (settings.allMiss?.available === 'Y' && user?.all_miss === 'Y') {
        const s = settings.allMiss;
        if (betAmount >= s.minBettingAmount) {
          const highOddsFolders = details.filter(
            d => s.minOdds === 0 || parseFloat(d.odds) >= s.minOdds
          );
          if (highOddsFolders.length >= s.minFolderCount) {
            if (missCount === details.length) {
              return 'all_miss';
            }
          }
        }
      }

      return null;
    },

    /**
     * 한폴낙/올미당(슬립) 신청 — UI 트리거 (loading 관리)
     */
    onClaimFreebetSlip: function (betSlipId, claimType) {
      const eventName = claimType === 'one_folder_miss' ? '한폴낙' : '올미당';
      if (!confirm(`${eventName} 프리벳을 신청하시겠습니까?`)) return;
      this.claimLoading.push(betSlipId);
      return this.claimFreebetSlip(betSlipId, claimType)
        .finally(() => {
          const i = this.claimLoading.indexOf(betSlipId);
          if (i > -1) this.claimLoading.splice(i, 1);
        });
    },

    /**
     * 리그이벤트(슬립) 적격 이벤트 목록
     * 백엔드 my-bets 응답을 받은 후, 슬립 이벤트 메타(allowedLeagues)로 클라이언트에서 한 번 더 필터링.
     * (기존 베팅 BettingResult.vue getLeagueEventEligible 패턴 동일)
     */
    getLeagueEventEligibleSlip: function (betSlip) {
      if (!betSlip) return [];
      if (this.$store.state.user.user?.league_event !== 'Y') return [];
      const backendEligible = betSlip.league_event_eligible_events || [];
      if (backendEligible.length === 0) return [];

      const allEvents = this.$store.getters["LEAGUE_EVENT_SLIP_SETTINGS"] || [];
      const details = betSlip.betDetails || [];

      const matchesAllowedLeague = (folder, allowedLeagues) => {
        return allowedLeagues.some((l) => (
          (l.id && Number(l.id) === Number(folder.league_id)) ||
          (l.nameEn && l.nameEn === folder.league_name) ||
          (l.nameKr && l.nameKr === folder.league_name)
        ));
      };

      return backendEligible.filter((eligible) => {
        const event = allEvents.find((e) => e.id === eligible.eventId);
        if (!event) return true; // 메타 못 찾으면 backend 판단 신뢰
        if (!event.allowedLeagues || event.allowedLeagues.length === 0) return true;

        const handling = event.nonAllowedLeagueHandling || 'exclude_count';
        if (handling === 'exclude_event') {
          // 비대상 리그 폴더가 하나라도 있으면 이벤트 제외
          return !details.some((d) => !matchesAllowedLeague(d, event.allowedLeagues));
        } else {
          // exclude_count — 대상 리그 폴더가 하나도 없으면 이벤트 제외
          return details.some((d) => matchesAllowedLeague(d, event.allowedLeagues));
        }
      });
    },

    /**
     * 베팅보너스(슬립) 적격 이벤트 — 백엔드 my-bets 응답 그대로
     */
    getBettingBonusEligibleSlip: function (betSlip) {
      if (!betSlip) return null;
      if (this.$store.state.user.user?.betting_bonus_event !== 'Y') return null;
      if (betSlip.betting_bonus_claimed) return null;
      if (betSlip.betting_bonus_claimable_after &&
          new Date() < new Date(betSlip.betting_bonus_claimable_after)) return null;
      return betSlip.betting_bonus_eligible_event || null;
    },

    onClaimLeagueEventSlip: function (betSlipId, eventId, eventName) {
      if (!confirm(`${eventName} 프리벳을 신청하시겠습니까?`)) return;
      this.claimLoading.push(betSlipId);
      this.claimLeagueEventSlip(betSlipId, eventId)
        .finally(() => {
          const i = this.claimLoading.indexOf(betSlipId);
          if (i > -1) this.claimLoading.splice(i, 1);
        });
    },

    onClaimBettingBonusSlip: function (betSlipId, eventId, eventName) {
      if (!confirm(`${eventName} 프리벳을 신청하시겠습니까?`)) return;
      this.claimLoading.push(betSlipId);
      this.claimBettingBonusSlip(betSlipId, eventId)
        .finally(() => {
          const i = this.claimLoading.indexOf(betSlipId);
          if (i > -1) this.claimLoading.splice(i, 1);
        });
    },

    /**
     * 한폴낙(슬립) 신청 — bet_slip ID를 betcode 자리에 전달, 백엔드가 자동 감지
     */
    claimFreebetSlip: function (betSlipId, claimType /* 'one_folder_miss' | 'all_miss' */) {
      return this.$store.dispatch('CLAIM_FREEBET_SLIP', {
        payload: { betcode: String(betSlipId), type: claimType },
      })
        .then((response) => {
          if (response.data?.success) {
            alert(response.data.msg);
            this.fetchBetSlips();
          } else {
            alert(response.data?.msg || '프리벳 지급에 실패했습니다.');
          }
        })
        .catch((err) => {
          alert(err.response?.data?.msg || err.response?.data?.error || '프리벳 지급 처리 중 오류가 발생했습니다.');
        });
    },

    /**
     * 리그이벤트(슬립) 신청
     */
    claimLeagueEventSlip: function (betSlipId, eventId) {
      return this.$store.dispatch('CLAIM_LEAGUE_EVENT_SLIP', {
        payload: { slipId: String(betSlipId), eventId },
      })
        .then((response) => {
          if (response.data?.success) {
            alert(response.data.msg);
            this.fetchBetSlips();
          } else {
            alert(response.data?.msg || '프리벳 지급에 실패했습니다.');
          }
        })
        .catch((err) => {
          alert(err.response?.data?.msg || err.response?.data?.error || '프리벳 지급 처리 중 오류가 발생했습니다.');
        });
    },

    /**
     * 베팅보너스(슬립) 신청
     */
    claimBettingBonusSlip: function (betSlipId, eventId) {
      return this.$store.dispatch('CLAIM_BETTING_BONUS_SLIP', {
        payload: { slipId: String(betSlipId), eventId },
      })
        .then((response) => {
          if (response.data?.success) {
            alert(response.data.msg);
            this.fetchBetSlips();
          } else {
            alert(response.data?.msg || '프리벳 지급에 실패했습니다.');
          }
        })
        .catch((err) => {
          alert(err.response?.data?.msg || err.response?.data?.error || '프리벳 지급 처리 중 오류가 발생했습니다.');
        });
    },

    /**
     * 베팅슬립 취소
     */
    cancelBetSlip: function (betSlipId) {
      if (!confirm("베팅을 취소하시겠습니까?")) {
        return;
      }

      // 로딩 상태 추가
      this.cancelLoading.push(betSlipId);

      this.$store.dispatch('BETSLIP_CANCEL', {
        bet_slip_id: betSlipId.toString()
      })
        .then((response) => {
          if (response.data.success) {
            alert(response.data.msg || '베팅이 취소되었습니다.');
            this.fetchBetSlips(); // 목록 새로고침
          } else {
            alert(response.data.msg || '베팅 취소에 실패했습니다.');
          }
        })
        .catch(err => {
          console.error('베팅 취소 오류:', err);
          alert(err.response?.data?.msg || err.response?.data?.error || '베팅 취소에 실패했습니다.');
        })
        .finally(() => {
          // 로딩 상태 제거
          const index = this.cancelLoading.indexOf(betSlipId);
          if (index > -1) {
            this.cancelLoading.splice(index, 1);
          }
        });
    },

    /**
     * 상태 필터 설정
     */
    setStatusFilter: function (status) {
      this.payload.status = status;
      this.payload.offset = 0; // 첫 페이지부터 다시 조회
      this.fetchBetSlips();
    },

    /**
     * 페이지네이션
     */
    loadMore: function () {
      if (this.pagination && this.pagination.hasMore) {
        this.payload.offset += this.payload.limit;
        this.fetchBetSlips(true);
      }
    },

    /**
     * 베팅슬립 취소 가능 여부 확인
     */
    canCancelBetSlip: function (betSlip) {
      // 대기 상태인 베팅슬립만 취소 가능, 인플레이는 취소 불가
      if (betSlip.type === 'betconstruct_inplay') return false;
      return betSlip.status === 'pending' && betSlip.result === 'wait';
    },

    /**
     * 베팅 결과 상태 텍스트
     */
    getMarketName: function (detail) {
      const hasKorean = (str) => str && /[가-힣]/.test(str);
      if (hasKorean(detail.market_name)) return detail.market_name;
      if (hasKorean(detail.market_type_name)) return detail.market_type_name;
      return detail.market_name || detail.market_type_name || '';
    },

    getTypeText: function (type) {
      const typeMap = {
        'betconstruct_inplay': '벳컨 인플레이',
        'betconstruct_korean': '벳컨 한국형',
        'betconstruct_european': '벳컨 유럽형',
        'betconstruct_special': '벳컨 스페셜',
        'lsport_korean': '엘스포츠 한국형',
        'lsport_european': '엘스포츠 유럽형',
        'lsport_special': '엘스포츠 스페셜',
      };
      return typeMap[type] || type;
    },

    getResultText: function (result) {
      const statusMap = {
        'wait': '대기',
        'hit': '적중', 
        'miss': '미적중',
        'exception': '적특',
        'cancelled': '취소'
      };
      return statusMap[result] || result;
    },

    /**
     * 베팅 상태 색상 클래스
     */
    getStatusClass: function (result) {
      const classMap = {
        'wait': 'text-gray',
        'hit': 'text-green', 
        'miss': 'text-red',
        'exception': 'text-yellow',
        'cancelled': 'text-gray'
      };
      return classMap[result] || 'text-gray';
    },

    /**
     * 세부 정보 토글
     */
    toggle: function (id) {
      console.log('Toggle called with id:', id);
      console.log('Current opened array:', this.opened);
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
        console.log('Removed from opened, new array:', this.opened);
      } else {
        this.opened.push(id);
        console.log('Added to opened, new array:', this.opened);
      }
    },

    /**
     * 금액 포맷팅 (콤마 추가)
     */
    formatAmount: function (amount) {
      return Number(amount).toLocaleString();
    },

    /**
     * 전체 베팅슬립 삭제
     */
    deleteAllBetSlips: function () {
      if (!confirm('모든 베팅슬립을 삭제하시겠습니까?')) {
        return;
      }
      // TODO: 베팅슬립 전체 삭제 API 구현 필요
      alert('베팅슬립 전체 삭제 기능은 아직 구현되지 않았습니다.');
    }
  },
};
</script>

<style scoped>
@import "https://pro.fontawesome.com/releases/v5.13.0/css/all.css";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to
  /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.tab_container {clear: both; float: left; width: 100%;}
.tab_content {padding: 10px 0 0 0;}
.my_search_wrap {width:100%; display:block; margin:0 0 10px 0}
.input_style01 {border:solid 1px #505455; background:none; height:40px; line-height:25px; padding:0 0 0 10px; color:#6b7f7f; width:100%; font-size: 15px;}


.snb_wrap {width:100%;  height:35px; line-height:35px; }
.snb_wrap ul li {float:left; margin:0 1px 0 0}
.snb_wrap ul li a{color:#ffffff}
.snb_on {padding:10px 8px 10px 8px; background:#a97bf5; color:#ffffff; font-weight:bold}
.snb {padding:10px 8px 10px 8px; background:#242829; color:#ffffff; font-weight:bold}


/* 2칸 2줄 Grid Menu : 충전신청 ,환전신청 , 포인트전화, 머니전화, 포인트 사용내역, 머니사용내역 */
.menu_2_2 {
  width:100%;
  display: table;
  background-color: #1c2021;
}

.menu_2_2 DIV {
  display: table-row;
  border-left: #2D3232 solid 1px;
  border-top: #2D3232 solid 1px;
}

.menu_2_2 DIV DIV{
  width:33.33%;
  height: 40px;
  border-right: #2D3232 solid 1px;
  border-bottom: #2D3232 solid 1px;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}

.menu_2_2 DIV DIV a {
  color:#6B7A7A;
  font-weight: bold;
}

.menu_2_2 DIV DIV.active{
  background-color: #252929;
}

.menu_2_2 DIV DIV.active a {
  color:#a97bf5;
  font-weight: bold;
}
#contents_wrap {float:left; width:100%;}
.contents {width:1330px; margin:0px auto; min-height:600px; }

.tab_container {clear: both; float: left; width: 100%;}
.tab_content {padding: 20px 0 0 0;}

/* 모바일 베팅 내역 스타일 */
.m_betting_div {
  margin-bottom: 20px;
  border-radius: 5px;
  overflow: hidden;
}

.total_betting_div {
  background-color: #1c2021;
  padding: 10px;
  border-radius: 5px;
  line-height: 1.2;
}

.total_betting_div table {
  width: 100%;
  margin: 0;
  line-height: 1.2;
}

.total_betting_div td {
  padding: 5px;
  border: none;
  background: transparent;
  color: #999;
  text-align: left;
  font-size: 12px;
}

.sub_betting_div {
  padding: 5px;
  margin-top: 2px;
  border-left: 3px solid;
  line-height: 1.2;
  background-color: #1c2021;
}

.sub_betting_div table {
  width: 100%;
  margin: 0;
  line-height: 1.2;
}

.sub_betting_div td {
  padding: 2px 5px;
  border: none;
  background: transparent;
  text-align: left;
}

/* 배경 색상 */
.total_betting_div.bg-y {
  background-color: #4a4520;
}

.total_betting_div.bg-r {
  background-color: #4a2020;
}

.total_betting_div.bg-g {
  background-color: #204a20;
}

.total_betting_div.bg-gr {
  background-color: #2a2a2a;
}

/* 보더 색상 */
.sub_betting_div.border-y {
  border-left-color: #ffcc00;
}

.sub_betting_div.border-r {
  border-left-color: #ff0000;
}

.sub_betting_div.border-g {
  border-left-color: #00ff00;
}

.sub_betting_div.border-gr {
  border-left-color: #999;
}

/* 텍스트 색상 */
.text-gray {
  color: #999 !important;
}

.text-green {
  color: #00ff00 !important;
}

.text-red {
  color: #ff0000 !important;
}

.text-yellow {
  color: #ffcc00 !important;
}

.orange--text {
  color: #ff9800 !important;
}

/* 유틸리티 클래스 */
.text-right {
  text-align: right !important;
}

.pr-3 {
  padding-right: 15px !important;
}

.pt-2 {
  padding-top: 10px !important;
}

.pb-2 {
  padding-bottom: 10px !important;
}
</style>